module.exports = __webpack_public_path__ + "assets/img/activity-time-8ee83109.png";